import type { LoaderFunction } from '@remix-run/node'
import { redirect } from '@remix-run/node'
import { isRouteErrorResponse, useRouteError } from '@remix-run/react'
import { getAuth } from '~/services/auth.server'

export const loader: LoaderFunction = async ({ request }) => {
  if (await getAuth(request)) throw redirect('/')

  // 404 only when user is not logged in
  throw new Response('Not Found', { status: 404 })
}

//export let handle = { i18n: ['error'] }

export default function Index() {
  return <></>
}

export function ErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="container relative flex flex-col items-center justify-center text-base-content">
        <div className="pt-16 text-center lg:scale-150 lg:pt-32">
          <div className="mb-5 max-w-xl text-9xl font-bold leading-none">404</div>
          <h1 className="sm:br-hidden mb-5 text-5xl font-semibold">Not Found</h1>
        </div>
      </div>
    )
  }

  return null
}
